export const decodeBase64 = (encodedValue: string): string => {
  const buff = Buffer.from(encodedValue, 'base64');
  const decodedId = buff.toString('ascii');
  const extractedInfo = decodedId.split(/[\s/]+/).pop();
  return extractedInfo || '';
};
